export default {
  quillGetHTML(inputDelta) {
    const tempQuill = new Quill(document.createElement('div'))

    tempQuill.setContents(inputDelta)
    return tempQuill.root.innerHTML
  },

  getContractText() {
    return document.getElementById('statement_of_work_contract') || document.getElementById('service_level_agreement_contract') || document.getElementById('master_service_agreement_contract')
  },

  setup() {
    const element = document.querySelector('.ql-input')
    const toolbar = [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      [{'direction': 'rtl'}],
      ['link'],
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      [{'align': []}],
      ['clean'],
    ]
    const editor = new Quill(element, {
      modules: {toolbar},
      theme: 'snow',
    });

    editor.on('text-change', () => {

      const contractText = this.getContractText()

      if (contractText) {
        contractText.value = this.quillGetHTML(editor.getContents())
      }
    });

    window.addEventListener('phx:base_contract_changed', (event) => {
      const contractText = document.getElementById('statement_of_work_contract')

      editor.root.innerHTML = event.detail.html
      if (contractText) {
        contractText.value = event.detail.html

      }
    })
  },

  mounted() {
    this.setup()
  },
}
